<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card min-height">
          <TableLoading v-if="sampleOrder.publicId === '0'"/>
          <div v-else class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">Invoice # {{sampleOrder.invoiceId}}</h4>
              <div class="mb-4">
                <img
                    src="@/assets/images/KikkomanNameLogo.png"
                    alt="logo"
                    height="20"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>From:</strong>
                  <br />Kikkoman East Africa <br/>P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                  <br />Pin P051667186Z
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  Sample Order by:<br />
                  <strong>{{sampleOrder.orderedBy}}</strong>
                </address>
                <address v-if="sampleOrder.customer !== null">
                  Customer:<br />
                  <strong>{{sampleOrder.customer.name}}</strong>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3"></div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Delivery Date:</strong>
                  <br />{{sampleOrder.deliveryDate}}
                  <br /><br />
                </address>
                <b-button v-if="checkForPermission(add_order_date_changes_permission)" v-b-modal.sample-invoice variant="primary">Change Delivery Date</b-button>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Order summary</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead class="table-light">
                <tr>
                  <th style="width: 70px">No.</th>
                  <th>Product Name</th>
                  <th>Order Unit</th>
                  <th class="text-sm-end">Unit Price</th>
                </tr>
                </thead>
                <tbody v-for="(item, index) in sampleOrder.orderItems" :key="item.publicId">
                <tr>
                  <td>{{index+1}}</td>
                  <td>{{item.item.productName}}</td>
                  <td>{{item.itemCount}}</td>
                  <td class="text-sm-end">Ksh {{item.grossItemTotal | formatNumber}}</td>
                </tr>
                </tbody>
              </table>
              <div class="row justify-content-between my-5">
                <div class="col-4"></div>
                <div class="col-4">
                  <div class="my-2 pb-2">
                    <strong>Total:</strong>
                    <p class="float-end">Ksh {{sampleOrder.grossOrderTotal | formatNumber}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-print-none">
              <span class="mb-3">Sample Order Status: <order-status-component :order_status="sampleOrder.status.orderStatusName"/></span>
              <div class="mt-3">
                <div v-if="checkForPermission(change_sample_order_status_permission)" class="row float-start">
                  <multiselect v-model="status" :options="sampleOrder.availableStatusChanges" open-direction="top"
                               placeholder="Select one" label="orderStatusName" track-by="orderStatusName">
                  </multiselect>
                  <b-button variant="danger" class="text-white mx-2 mt-2"  @click="chngeOrderStatus(sampleOrder.publicId)" :disabled="ordersLoading">
                    Change Order Status
                  </b-button>
                </div>
              </div>
            </div>
            <b-modal
                id="sample-invoice"
                centered
                hide-footer
                hide-header
                title-class="font-18">
              <div class="p-2">
                <h3>Change Delivery Date</h3>
                <change-delivery-date-modal-component @changeDate="changeSampleDeliveryDate" :current_date="sampleOrder.deliveryDate"/>
                <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('sample-invoice')">Close</b-button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import ChangeDeliveryDateModalComponent from "@/components/orders/change-delivery-date-modal-component";
import {SINGLE_SAMPLE_ORDER} from "@/gql/orders";
import {mapActions, mapGetters} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import Multiselect from "vue-multiselect";
import {permissions} from "@/router/permissions";
import OrderStatusComponent from "@/components/orders/order-status-component";

export default {
  page: {
    title: "Sample Order Details",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {OrderStatusComponent, TableLoading, ChangeDeliveryDateModalComponent, PageHeader, Layout, Multiselect},
name: "sample-invoice",
  data() {
    return {
      title: "Sample Order Details",
      items: [
        {
          text: "Sample Orders",
          href: routeItems.sample_orders_route
        },
        {
          text: "Sample Order Details",
          active: true
        }
      ],
      sampleOrder: {
        publicId: '0',
        invoiceId: "",
        deliveryDate: "",
        orderedBy:"",
        customer: {
          name : ""
        },
        status: {
          orderStatusName:"",
          isOrderCompleteStatus: true,
          isOrderCancelledStatus: true,
        },
        orderItems: [{
          publicId: "",
          item: {
            productName: "",
            qpoUnit:""
          },
          itemCount: "",
          grossItemTotal: "",
        }],
        grossOrderTotal: "",
      },
      status: '',
      change_sample_order_status_permission: permissions.change_sample_order_status_permission,
      add_order_date_changes_permission: permissions.add_order_date_changes_permission,
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading'
    }),
  },
  apollo: {
    sampleOrder: {
      query: SINGLE_SAMPLE_ORDER,
      variables(){
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    ... mapActions({
      changeOrderDeliveryDate: 'orders/changeOrderDeliveryDate',
      changeSampleOrderStatus: 'orders/changeSampleOrderStatus',
    }),
    async changeSampleDeliveryDate(date){
      const data = {
        id: this.sampleOrder.publicId,
        newDate: date,
        isOrder: false
      }
      await this.changeOrderDeliveryDate(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrder.refetch()
        }

      })
    },
    async chngeOrderStatus(sampleOrderId){
      if (this.status !== ''){
        const data = {sampleOrderId: sampleOrderId ,statusId: this.status.publicId}
        await this.changeSampleOrderStatus(data).then(resp => {
          if(resp.message){
            successToast(`${resp.message}`)
            this.$apollo.queries.sampleOrder.refetch()
          }
        })
      }
    },
  }
}
</script>

<style scoped>

</style>
